import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 88690 72170"
    {...props}
  >
    <path
      d="m419 420 43925 26734L88271 420 44344 71236z"
      style={{
        fill: "#2b2a29",
        stroke: "#2b2a29",
        strokeWidth: 984.466,
      }}
      className="fill stroke1"
    />
  </svg>
)
export default SvgComponent
